// Session Deepflow (jeton de 7 jours) : renouvelée chaque jour tant qu'on se sert de l'application, et jamais de
// rechargement de page sur un jeton refusé pendant un enregistrement de réunion — l'enregistreur vit dans l'onglet
// (réunion du 2026-10-15 : jeton expiré en pleine réunion, page renvoyée vers /login, enregistrement coupé).

import { rememberReturnPath } from './returnPath';

const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const apiBaseUrl = process.env.NODE_ENV === 'development' ? baseUrl : `${baseUrl}/api`;

export const SESSION_EXPIRED_EVENT = 'deepflow-session-expired';
const RENEW_AFTER_S = 24 * 3600;

let holds = 0;

// Tant qu'un enregistrement tourne, la page doit rester ouverte ; renvoie la fonction qui libère.
export const keepPageOpen = () => {
  holds += 1;
  let released = false;
  return () => {
    if (released) return;
    released = true;
    holds -= 1;
  };
};

// Jeton refusé (401) : retour à la connexion, sauf pendant un enregistrement où l'on prévient sans quitter la page
// (l'utilisateur se reconnecte dans un autre onglet ; le nouveau jeton, partagé par localStorage, sert aussitôt ici).
export const sessionExpired = () => {
  if (holds > 0) {
    window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT));
    return;
  }
  localStorage.removeItem('auth_token');
  rememberReturnPath();
  window.location.href = '/login';
};

const issuedAt = (token) => {
  try {
    return JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))).iat || 0;
  } catch {
    return 0;
  }
};

// Jeton émis il y a plus d'un jour : on en demande un neuf (7 jours de plus). Sans effet sinon.
export const renewSession = async () => {
  const token = localStorage.getItem('auth_token');
  if (!token || Date.now() / 1000 - issuedAt(token) < RENEW_AFTER_S) return false;
  try {
    const response = await fetch(`${apiBaseUrl}/auth/refresh`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) return false;
    const { token: renewed } = await response.json();
    // Une reconnexion dans un autre onglet entre-temps garde son jeton.
    if (renewed && localStorage.getItem('auth_token') === token) localStorage.setItem('auth_token', renewed);
    return true;
  } catch {
    return false;
  }
};
